if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("side-cart") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            // Add hidden property for cart recommendations
            this.addCartRecommendationsTracking(opener);

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          "variant-radios,variant-selects"
        );
        if (!variantPicker) return;

        variantPicker.setAttribute("data-update-url", "false");
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog =
          this.productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios, product-info")
          .forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }

      addCartRecommendationsTracking(opener) {
        // Check if this quick-add modal is being opened from cart recommendations
        let isFromCartRecommendations =
          opener &&
          ((opener.hasAttribute("data-debug") &&
            opener.getAttribute("data-debug") ===
              "cart-recommendations-form") ||
            opener.closest('[data-debug="cart-recommendations-form"]'));

        // Fallback: check if we're in a cart drawer context
        if (!isFromCartRecommendations) {
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            // Check multiple possible open states
            const isOpen =
              cartDrawer.classList.contains("active") ||
              cartDrawer.classList.contains("open") ||
              cartDrawer.classList.contains("drawer--open") ||
              cartDrawer.hasAttribute("open");

            if (isOpen) {
              // Look for any cart recommendation buttons in the cart drawer
              const cartRecButtons = cartDrawer.querySelectorAll(
                '[data-debug="cart-recommendations-form"]'
              );

              if (cartRecButtons.length > 0) {
                isFromCartRecommendations = true;
              }
            }
          }
        }

        // Additional fallback: check if we're in a cart recommendations context by looking at the URL or page context
        if (!isFromCartRecommendations) {
          // Check if we're on a cart page or if cart recommendations are visible
          const cartRecommendationsVisible =
            document.querySelector(
              '[data-debug="cart-recommendations-form"]'
            ) !== null;
          const cartDrawerVisible =
            document.querySelector("cart-drawer") !== null;
          const isCartPage = window.location.pathname.includes("/cart");

          // If we're in a cart context and this is a quick-add modal, assume it's from cart recommendations
          if (
            cartRecommendationsVisible ||
            (cartDrawerVisible && !isCartPage)
          ) {
            isFromCartRecommendations = true;
          }
        }

        if (isFromCartRecommendations) {
          // Find the product form in the modal
          const productForm = this.modalContent.querySelector(
            'form[data-type="add-to-cart-form"]'
          );

          if (productForm) {
            // Check if hidden property already exists
            let hiddenPropertyInput = productForm.querySelector(
              'input[name="properties[_upsell_source]"]'
            );

            if (!hiddenPropertyInput) {
              // Create and add the hidden property input
              hiddenPropertyInput = document.createElement("input");
              hiddenPropertyInput.type = "hidden";
              hiddenPropertyInput.name = "properties[_upsell_source]";
              hiddenPropertyInput.value = "cart_recommendations";

              // Insert it after the variant ID input
              const variantInput =
                productForm.querySelector('input[name="id"]');
              if (variantInput) {
                variantInput.parentNode.insertBefore(
                  hiddenPropertyInput,
                  variantInput.nextSibling
                );
              } else {
                // Fallback: add to the beginning of the form
                productForm.insertBefore(
                  hiddenPropertyInput,
                  productForm.firstChild
                );
              }
            }
          }
        }
      }
    }
  );
}
